import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.type.paypal': {
    id: 'payment.type.paypal',
    defaultMessage: 'PayPal',
    description: 'The alt text for image button for paypal payment type',
  },
});

export default messages;
